import { render, staticRenderFns } from "./FormRepeaterItemComponent.vue?vue&type=template&id=2bff0ecc"
import script from "./FormRepeaterItemComponent.vue?vue&type=script&lang=js"
export * from "./FormRepeaterItemComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports